import BaseComponent from 'foundation/base-component';
import Cookies from 'js-cookie';
import basketService from '../../../general/js/basket/basket-service';
import { BALLOT_ORDER_FILE_NUMBER_COOKIE_NAME } from '../../../general/js/basket/constants';

export default class BasketIcon extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.init();
        this.onBasketStateUpdate = this.onBasketStateUpdate.bind(this);
        this.onBallotBasketStateUpdate = this.onBallotBasketStateUpdate.bind(this);
    }

    static getRequiredRefs() {
        return [
            'basketLink',
            'basketTooltip'
        ];
    }

    init() {
        this.basketIsEmpty = true;
        this.ballotBasketIsEmpty = true;
        this.ballotBasketUrl = '';
        this.basketUrl = '';

        this.options.forEach((basketItem) => {
            basketItem.isBallotBasket ?
                this.ballotBasketUrl = basketItem.basketLink.url :
                this.basketUrl = basketItem.basketLink.url;
        });

        if (this.getCookie(BALLOT_ORDER_FILE_NUMBER_COOKIE_NAME) !== '' &&
        this.ballotBasketUrl !== '') { this.ballotBasketIsEmpty = false; }

        basketService.onBasketUpdate(this.onBasketStateUpdate);
        basketService.onBallotBasketUpdate(this.onBallotBasketStateUpdate);
    }

    onBasketStateUpdate = (basket) => {
        if (basket === null) return;

        basket.isEmpty ? this.basketIsEmpty = true : this.basketIsEmpty = false;

        if (this.basketIsEmpty && this.ballotBasketIsEmpty) { this.element.classList.remove('is-filled'); }

        this.removeListeners();
        this.addListeners();
    };

    onBallotBasketStateUpdate = (basket) => {
        if (basket === null && this.getCookie(BALLOT_ORDER_FILE_NUMBER_COOKIE_NAME) === '') return;

        if (this.ballotBasketUrl !== '') {
            basket.isEmpty && this.getCookie(BALLOT_ORDER_FILE_NUMBER_COOKIE_NAME) === '' ? this.ballotBasketIsEmpty = true : this.ballotBasketIsEmpty = false;
        }

        if (this.basketIsEmpty && this.ballotBasketIsEmpty) { this.element.classList.remove('is-filled'); }

        this.removeListeners();
        this.addListeners();
    };

    addListeners() {
        if (this.basketIsEmpty && !this.ballotBasketIsEmpty) {
            this.element.classList.add('is-filled');
            this.addListener(this.refs.basketLink, 'click', () => { location.href = this.ballotBasketUrl; });
        }
        if (!this.basketIsEmpty && this.ballotBasketIsEmpty) {
            this.element.classList.add('is-filled');
            this.addListener(this.refs.basketLink, 'click', () => { location.href = this.basketUrl; });
        }
        if (!this.basketIsEmpty && !this.ballotBasketIsEmpty) {
            this.element.classList.add('is-filled');

            this.addListener(this.refs.basketLink, 'click', this.onUserButtonClick);
            this.addListener(document, 'keydown', this.onkeydown);
            this.addListener(document, 'click', this.outerClickHandle);
            this.addListener(document, 'touchstart', this.outerClickHandle);
        }
    }

    onUserButtonClick = () => {
        if (!this.refs.basketTooltip) return;
        if (this.refs.basketTooltip.classList.contains('is-visible')) { this.refs.basketTooltip.classList.remove('is-visible'); } else { this.refs.basketTooltip.classList.add('is-visible'); }
    };

    onkeydown = (event) => {
        if (event.keyCode === 27) {
            if (!this.refs.basketTooltip) return;
            this.refs.basketTooltip.classList.remove('is-visible');
        }
    };

    outerClickHandle = (event) => {
        if ((this.refs.basketTooltip && !this.refs.basketTooltip.contains(event.target)) &&
            (this.refs.basketLink && !this.refs.basketLink.contains(event.target))) { this.refs.basketTooltip.classList.remove('is-visible'); }
    };

    getCookie(cookieName) {
        const cookie = Cookies.get(cookieName);
        return cookie && cookie !== '0' ? cookie : '';
    }
}
